<template>
    <div>
        <div class="trtc" v-if="activeCall">
            <div class="callMsg">
                <!-- 当前页是被呼叫方 -->
                <div class="call__left" v-if="isCallee">
                    <div class="call__name">{{ callName }}</div>
                    <div class="call__tips" v-if="speaking">正在和你进行{{ callTypeName }}通话</div>
                    <div class="call__tips" v-else>正在邀请你进行{{ callTypeName }}通话</div>
                </div>
                <!-- 当前页是呼叫方 -->
                <div class="call__left" v-else>
                    <div class="call__name">{{ callName }}</div>
                    <div class="call__tips" v-if="speaking">正在和你进行{{ callTypeName }}通话</div>
                    <div class="call__tips" v-else>正在等待对方接受{{ callTypeName }}通话</div>
                </div>
                <!-- 当前页被呼叫方（且未接起时）才有接起按钮 -->
                <div class="accept" :class="isCallee && !speaking ? '' : 'accept--hide'">
                    <div class="trtc__video" v-if="isVideo" @click="initAnswer">
                        <img :src="icons.video" width="40" height="40" />
                    </div>
                    <div class="trtc__voice" v-else @click="initAnswer">
                        <img :src="icons.audio" width="40" height="40" />
                    </div>
                </div>
                <div class="hangup" @click="initHangup">
                    <img :src="icons.hangup" width="40" height="40" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import logReport from './js/monitor/qdMonitor';
import { stateTimer } from './js/utils';
import videoRing from './js/videoRing';
import { EVENTTYPES } from './js/constants';
import pc from './js/mixins/pc';
export default {
  props: {
    wpaDetail: {
      type: Object,
      default: () => ({}),
    },
    // 接待详情
    employeeInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [pc],
  data() {
    return {
      icons: {
        video: require('./assets/img/video_green.png'),
        audio: require('./assets/img/audio_green.png'),
        hangup: require('./assets/img/hangup.png'),
      },
      roomid: '',
      mediaType: '', // 1视频 2音频
      activeCall: false,
      isCallee: false, // 是否被呼叫方
      speaking: false, // 是否已接通
    };
  },
  computed: {
    isVideo() {
      return this.mediaType === 1;
    },
    callTypeName() {
      return this.isVideo ? '视频' : '语音';
    },
    callName() {
      console.log(this.employeeInfo);
      return this.employeeInfo.name || '未知';
    },
  },
  methods: {
    // 接听
    initAnswer() {
      this.activeCall = false;
      this.userAction = 'receive';
      this.dir = 'b2c';
      videoRing.stop();
      if (this.surportTRTC) {
        // 被叫,接通，更新状态
        logReport({ message: `音视频:接听,${this.roomid}` });
        stateTimer.clear('dialling_timeout_timer');
        this.openRoom();
      } else {
        this.checkTRTCFaile();
      }
    },
    // 拒绝接听
    initHangup() {
      this.activeCall = false;
      logReport({ message: `音视频:挂断,${this.roomid}` });
      logReport({ message: '音视频:ring->idle:hangup' }, false);
      this.videoAct(EVENTTYPES.recRefuse);
      this.exitSdk({ event: 'hangup' });
    },
    // 显示被叫状态
    showDialling(data) {
      logReport({ message: `音视频:被叫,开始响铃${JSON.stringify(data)}` });
      console.log(this.wpaDetail);
      console.log(this.employeeInfo);
      const { uint32_call_type, uint32_roomid } = data;
      this.mediaType = uint32_call_type;
      this.roomid = uint32_roomid;
      this.activeCall = true;
      this.isCallee = true;
      videoRing.play();
    },
    // 停止响铃
    stopRing() {
      this.activeCall = false;
      videoRing.stop();
    },
  },
};
</script>

<style lang="less">
.trtc {
    box-sizing: border-box;
    position: fixed;
    bottom: 50px;
    right: 50px;
    width: 276px;
    height: 70px;
    color: #fff;
    border-radius: 6px;
    background-color: blue;
    z-index: 100;
    .callMsg {
        display: flex;
        align-items: center;
        padding: 14px;
        opacity: 0.95;
        background-color: #1e1e1e;
        border-radius: 6px;
        .call__left {
            flex: 1;
            .call__name {
                font-family: PingFangSC-Medium;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 20px;
            }
            .call__tips {
                margin-top: 5px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                letter-spacing: 0;
            }
        }
        .accept--hide {
            visibility: hidden;
        }
        .trtc__video,
        .trtc__voice,
        .hangup {
            margin-left: 12px;
            img {
                width: 40px;
                height: 40px;
                &:hover {
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
